import PropTypes from 'prop-types';
import { FrameWithStickyTitle } from 'components/BrandSlides/BrandSlides';
import { ensureArray, safeMap, ensureString } from 'utils/safeArray';

export default function ProjectCharter({ title, fields, timeline, accent_color }) {
  const safeFields = ensureArray(fields);
  const safeTimeline = ensureArray(timeline);
  
  return (
    <FrameWithStickyTitle title={title} accentColor={accent_color}>
      <div className="pt-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 items-start">
          {/* Left Column: Fields */}
          <div className="flex flex-col gap-3 md:gap-5">
            {safeMap(safeFields, (field, i) => {
              const safeField = field && typeof field === 'object' ? field : {};
              return (
                <div key={i} className="text-left">
                  <h4 className="text-base md:text-lg font-semibold text-slate-800 mb-1 md:mb-1.5">{ensureString(safeField.name)}</h4>
                  <div
                    className="text-xs md:text-sm text-slate-600 prose prose-sm md:prose prose-li:text-slate-600 prose-strong:text-slate-700"
                    dangerouslySetInnerHTML={{ __html: ensureString(safeField.content) }}
                  />
                </div>
              );
            })}
          </div>

          {/* Right Column: Timeline */}
          <div className="flex flex-col gap-2">
            <h4 className="text-base md:text-lg font-semibold text-slate-800 mb-1 md:mb-1.5">Project Timeline</h4>
            {safeMap(safeTimeline, (phase, i) => {
              const safePhase = phase && typeof phase === 'object' ? phase : {};
              return (
                <div key={i} className="text-left p-2.5 md:p-3.5 border-l-4 bg-slate-50 rounded-r-lg" style={{ borderColor: accent_color || '#cc0000' }}>
                  <div className="flex items-start justify-between gap-2 md:gap-2.5 mb-1 md:mb-1.5">
                    <span className="text-xs md:text-sm font-bold text-slate-600">{ensureString(safePhase.title)}</span>
                    <span className="text-[10px] md:text-xs font-medium text-slate-600 bg-slate-200 px-1.5 md:px-2 py-0.5 rounded whitespace-nowrap">{ensureString(safePhase.duration)}</span>
                  </div>
                  <p className="text-xs md:text-sm text-slate-600 mt-0.5 md:mt-1">{ensureString(safePhase.description)}</p>
                </div>
              );
            })}
          </div>
        </div>
        
        {/* Disclaimer Footer */}
        <div className="mt-8 pt-4 border-t border-slate-200">
          <p className="text-[11px] text-slate-400 text-center italic leading-snug">
            Disclaimer: This content is AI-generated for preliminary brainstorming purposes only and should not be considered final or authoritative.
          </p>
        </div>
      </div>
    </FrameWithStickyTitle>
  );
}

ProjectCharter.propTypes = {
  title: PropTypes.string,
  fields: PropTypes.array,
  timeline: PropTypes.array,
  accent_color: PropTypes.string,
};
